import { Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { ConfluencePages, UserRole } from '../enums'
import { UserManualProvider } from '../contexts/userManual'
import RuuviTags from '../pages/pages/RuuviTags'
import RuuviTag from '../pages/pages/RuuviTag'
import RuuviTagStats from '../pages/pages/RuuviTagStats'
import RuuviTagAlerts from '../pages/pages/RuuviTagAlerts'
import LoadingState from '../components/LoadingState'

export default [
  {
    path: '/ruuvi-tags',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <UserManualProvider pageId={ConfluencePages.RUUVI_TAGS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <RuuviTags />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/ruuvi-tags/:id',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.RUUVI_TAGS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <RuuviTag />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: 'ruuvi-tags/:id/alerts',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.INSTALLER,
          UserRole.USER,
          UserRole.MANUFACTURER
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.RUUVI_TAGS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <RuuviTagAlerts />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: 'ruuvi-tags/:id/stats',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <UserManualProvider pageId={ConfluencePages.RUUVI_TAGS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <RuuviTagStats />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  }
]
